import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';

export default graphql(
  gql`
    mutation RequestSignupEmailCode($input: RequestSignupEmailCodeInput!) {
      requestSignupEmailCode(input: $input) {
        success
      }
    }
  `,
  {
    props: ({ mutate }) => ({
      requestSignupEmailCode: async (input, secretKey) => {
        return mutate({
          variables: { input },
          context: {
            headers: {
              secret_key: secretKey,
            },
          },
        });
      },
    }),
  }
);
